import type {
  PluginContainerData,
  PluginContainerData_Width,
  PluginContainerData_Width_Type,
} from 'ricos-schema';
import { Node_Type } from 'ricos-schema';
import toCamelCase from 'to-camel-case';

import { NO_WRAP, WRAP } from '../../../consts';

export const convertContainerData = (
  data: { containerData?: PluginContainerData; config },
  nodeType: string
) => {
  if (!data.containerData) {
    return;
  }

  const { width, alignment, spoiler, height, textWrap = true } = data.containerData;
  const { enabled = false, description, buttonText } = spoiler ?? {};

  const config = {
    ...data.config,
    size: getSize(nodeType, width?.size, width?.custom),
    width: getWidth(nodeType, width?.custom),
    height: height?.custom && parseInt(height.custom),
    alignment: alignment?.toLowerCase(),
    spoiler: spoiler && {
      enabled,
      description,
      buttonContent: buttonText,
    },
    textWrap: textWrap ? WRAP : NO_WRAP,
  };
  return config;
};

const getSize = (
  nodeType: string,
  size: PluginContainerData_Width_Type | undefined,
  customWidth: PluginContainerData_Width['custom'] | undefined
) => {
  const hasCustomWidth = customWidth !== undefined;

  if ((nodeType === Node_Type.IMAGE || nodeType === Node_Type.BUTTON) && hasCustomWidth) {
    return 'inline';
  }
  if (nodeType === Node_Type.BUTTON) {
    return 'small';
  }
  if (nodeType === Node_Type.MAP) {
    return 'content';
  }
  if (size) {
    return toCamelCase(size);
  }
};

const getWidth = (nodeType: string, width: string | undefined) => {
  if (width) {
    return parseInt(width);
  }
  if (!width && nodeType === Node_Type.BUTTON) {
    return 'fit-content';
  }
};
